(function($) {

  $(document).ready(function() {

    $("[data-toggle=\"tooltip\"]").tooltip();

  });

})(jQuery);
